import { shallowEqual, useSelector } from 'react-redux';
import { getPayoutConfig } from '../selectors';
import { IStore } from 'store/interface';
import { IWithdrawalGate } from '../interfaces/reducers.withdrawal.interface';

export const usePayoutConfig = (method: string) => ({
  config: useSelector<IStore, IWithdrawalGate>(getPayoutConfig(method), shallowEqual),
});
